(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["badlands-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('badlands-banner')) {
  customElements.define('badlands-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.dataset.ready = 'true';
      this.button = this.querySelector('.bb-banner__toggle');
      this.button.hidden = this.dataset.autoscroll !== 'true';
      this.button.addEventListener('click', () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        this.button.textContent = paused ? this.button.dataset.play : this.button.dataset.pause;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["badlands-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('badlands-gear-carousel')) {
  customElements.define('badlands-gear-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.bb-products');
      this.toggle = this.querySelector('[data-toggle]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.visible = false;
      this.querySelector('.bb-carousel-controls').hidden = false;
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
      this.querySelector('[data-previous]').addEventListener('click', () => this.move(-1), options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateButton();
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('pointerdown', () => {
        this.paused = true;
        this.updateButton();
      }, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.updateButton();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
      }, { threshold: .25 });
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (this.paused || !this.visible || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
        this.move(1);
      }, Number(this.dataset.interval) || 5000);
      this.updateButton();
    }
    updateButton() {
      this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
    }
    move(direction) {
      const first = this.track.firstElementChild;
      if (!first) return;
      const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || '0');
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      if (maximum < 2) return;
      let left = this.track.scrollLeft + direction * step;
      if (direction > 0 && this.track.scrollLeft >= maximum - 2) left = 0;
      if (direction < 0 && this.track.scrollLeft <= 2) left = maximum;
      this.track.scrollTo({ left: Math.max(0, Math.min(maximum, left)), behavior: this.motion.matches ? 'auto' : 'smooth' });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearInterval(this.timer);
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["badlands-quote"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bq-builder]').forEach((builder)=>{
  const contactForm=builder.querySelector('form.bq-form');
  const formType=contactForm&&contactForm.querySelector('input[name="form_type"]');
  const utf8=contactForm&&contactForm.querySelector('input[name="utf8"]');
  if(formType)formType.value='contact';
  if(utf8)utf8.value='✓';
  const decoration=builder.querySelector('[data-bq-decoration]');
  const quantity=builder.querySelector('input[name="contact[Estimated quantity]"]');
  const art=builder.querySelector('[data-bq-art]');
  const estimator=builder.querySelector('[data-bq-estimator]');
  const dtfApparel=builder.querySelector('[data-bq-dtf-apparel]');
  const emb=builder.querySelector('[data-bq-emb]');
  const hats=builder.querySelector('[data-bq-hats]');
  const shirt=builder.querySelector('[data-bq-shirt]');
  const print=builder.querySelector('[data-bq-print]');
  const printTwo=builder.querySelector('[data-bq-print-two]');
  const stitches=builder.querySelector('[data-bq-stitches]');
  const hat=builder.querySelector('[data-bq-hat]');
  const addons=[...builder.querySelectorAll('[data-bq-addon]')];
  const dtfHatAddons=[...builder.querySelectorAll('[data-bq-dtf-addon]')];
  const embAddons=builder.querySelector('[data-bq-emb-addons]');
  const dtfHatAddonGroup=builder.querySelector('[data-bq-dtf-hat-addons]');
  const projectTypes=[...builder.querySelectorAll('input[name="contact[Project type]"]')];
  const total=builder.querySelector('[data-bq-total]');
  const breakdown=builder.querySelector('[data-bq-breakdown]');
  const artFee=builder.querySelector('[data-bq-art-fee]');
  const estimateField=builder.querySelector('[data-bq-estimate-field]');
  const cents=(select)=>select&&select.selectedOptions[0]?Number(select.selectedOptions[0].dataset.cents||0):0;
  const money=(value)=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(value/100);
  const setGroup=(group,visible)=>{
    if(!group)return;
    group.hidden=!visible;
    group.querySelectorAll('input,select,textarea').forEach((field)=>{field.disabled=!visible;});
  };
  const update=()=>{
    const method=decoration.value;
    const project=builder.querySelector('input[name="contact[Project type]"]:checked');
    const isHat=project&&project.value==='Hats';
    const count=Math.max(0,Number(quantity.value||0));
    const fee=art.value==='alteration'||art.value==='design'?2500:0;
    decoration.querySelectorAll('option').forEach((option)=>{
      option.disabled=(isHat&&(option.value==='screen-printing'||option.value==='laser-engraving'))||(!isHat&&option.hasAttribute('data-bq-hat-only'));
    });
    if((isHat&&(method==='screen-printing'||method==='laser-engraving'))||(!isHat&&method==='laser-patch')){decoration.value='';}
    const activeMethod=decoration.value;
    estimator.hidden=activeMethod!=='dtf'&&activeMethod!=='embroidery'&&activeMethod!=='laser-patch';
    setGroup(dtfApparel,activeMethod==='dtf'&&!isHat);
    setGroup(emb,activeMethod==='embroidery');
    setGroup(hats,isHat&&(activeMethod==='dtf'||activeMethod==='embroidery'||activeMethod==='laser-patch'));
    setGroup(embAddons,isHat&&activeMethod==='embroidery');
    setGroup(dtfHatAddonGroup,isHat&&activeMethod==='dtf');
    artFee.hidden=fee===0;
    if(activeMethod==='dtf'){
      const dtfDecoration=isHat?400+centsFromInputs(dtfHatAddons):cents(print)+cents(printTwo);
      const unit=(isHat?cents(hat):cents(shirt))+dtfDecoration;
      if(unit>0&&count>0&&(!isHat||cents(hat)>0)){
        const amount=unit*count+fee;
        total.textContent=money(amount);
        breakdown.textContent=count+' items × '+money(unit)+' each'+(isHat?' ('+money(cents(hat))+' blank + '+money(dtfDecoration)+' DTF)':'')+(fee?' + $25.00 one-time artwork fee':'');
        estimateField.value='DTF estimate: '+money(amount)+' ('+count+' × '+money(unit)+(fee?' + $25 artwork fee':'')+')';
      }else{
        total.textContent='—';
        breakdown.textContent=isHat?'Choose a hat style and quantity to see an estimate. Styles without a listed price are confirmed manually.':'Choose a shirt size, print location and quantity to see an estimate.';
        estimateField.value='';
      }
    }else if(activeMethod==='laser-patch'){
      const blankPrice=cents(hat);
      const patchPrice=1000;
      if(count>=5&&blankPrice>0){
        const unit=blankPrice+patchPrice;
        const amount=unit*count+fee;
        total.textContent=money(amount);
        breakdown.textContent=count+' hats × '+money(unit)+' each ('+money(blankPrice)+' blank + '+money(patchPrice)+' laser-engraved patch)'+(fee?' + $25.00 one-time artwork fee':'');
        estimateField.value='Laser-engraved patch estimate: '+money(amount)+' ('+count+' × '+money(unit)+(fee?' + $25 artwork fee':'')+')';
      }else{
        total.textContent='—';
        breakdown.textContent=count>0&&count<5?'Laser-engraved patches require a minimum of 5 hats.':'Choose a priced hat style and enter at least 5 hats to see an estimate.';
        estimateField.value='';
      }
    }else if(activeMethod==='embroidery'){
      const stitchCount=Math.max(0,Number(stitches.value||0));
      let rate=200;
      if(count>=150){rate=100}else if(count>=100){rate=125}else if(count>=25){rate=155}
      const stitchPrice=Math.ceil(stitchCount/1000)*rate;
      const addonPrice=isHat?addons.filter((input)=>input.checked).reduce((sum,input)=>sum+Number(input.dataset.bqAddon||0),0):0;
      const blankPrice=isHat?cents(hat):0;
      if(count>0&&stitchCount>0&&(!isHat||blankPrice>0)){
        const unit=stitchPrice+addonPrice+blankPrice;
        const amount=unit*count+fee;
        total.textContent=money(amount);
        breakdown.textContent=count+' items × '+money(unit)+' each ('+money(stitchPrice)+' embroidery'+(blankPrice?' + '+money(blankPrice)+' blank':'')+(addonPrice?' + '+money(addonPrice)+' extra locations':'')+')'+(fee?' + $25.00 one-time artwork fee':'');
        estimateField.value='Embroidery estimate: '+money(amount)+' ('+count+' × '+money(unit)+(fee?' + $25 artwork fee':'')+')';
      }else{
        total.textContent='—';
        breakdown.textContent=isHat?'Choose a hat, quantity and stitch count to see an estimate. Other SanMar styles are confirmed manually.':'Enter quantity and estimated stitch count to see decoration pricing; garment cost is not included.';
        estimateField.value='';
      }
    }
  };
  const centsFromInputs=(inputs)=>inputs.filter((input)=>input.checked).reduce((sum,input)=>sum+Number(input.dataset.bqDtfAddon||0),0);
  [decoration,quantity,art,shirt,print,printTwo,stitches,hat,...addons,...dtfHatAddons,...projectTypes].forEach((field)=>field&&field.addEventListener('input',update));
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["washakie-product"]) return;
  try {
    
function initWashakieProducts(){
 document.querySelectorAll('[data-wc-product]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const variants=JSON.parse(root.querySelector('[data-wc-variants]').textContent);
  const selects=[...root.querySelectorAll('[data-wc-option]')];
  const input=root.querySelector('[data-wc-id]');
  const initial=variants.find(v=>String(v.id)===input.value)||variants[0];
  const choose=(start=0)=>{
   for(let i=start;i<selects.length;i++){
    const matches=variants.filter(v=>selects.slice(0,i).every((s,j)=>v.options[j]===s.value));
    const values=[...new Set(matches.map(v=>v.options[i]))];
    const old=selects[i].value;
    selects[i].replaceChildren(...values.map(value=>new Option(value,value)));
    selects[i].value=values.includes(old)?old:values[0];
   }
   const variant=variants.find(v=>selects.every((s,i)=>v.options[i]===s.value));
   const add=root.querySelector('[data-wc-add]');
   add.disabled=!variant||!variant.available;add.textContent=variant&&variant.available?root.dataset.add:root.dataset.unavailable;
   if(!variant)return;
   input.value=variant.id;
   root.querySelector('[data-wc-price]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:root.dataset.currency||'USD'}).format(variant.price/100);
   if(root.dataset.isCap!=='true'){
    const back=root.dataset.isBack==='true'||variant.options[0].includes('zip hoodie');
    const placement=back?root.dataset.back:root.dataset.front;
    root.querySelector('[data-wc-placement]').textContent=placement;
    root.querySelector('[data-wc-placement-input]').value=placement;
    root.querySelector('[data-wc-print-input]').value=variant.options[0].includes('6-inch')?root.dataset.medium:root.dataset.large;
   }
   const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url);
  };
  selects.forEach((select,i)=>{select.value=initial.options[i];select.addEventListener('change',()=>choose(i+1));});
  root.querySelector('[data-wc-selectors]').hidden=false;
  root.querySelector('[data-wc-selectors]').style.display='grid';root.querySelector('[data-wc-selectors]').style.gap='18px';
  choose(0);
 });
}
initWashakieProducts();document.addEventListener('shopify:section:load',initWashakieProducts);

  } catch(e) { console.error(e); }
})();
})();
